import React from 'react';
import { useHistory } from 'react-router-dom';
import ResetPasswordTemplate from '@rexmas/rexmas-shared/lib/components/templates/login/ResetPassword';
import { useActions, useSimpleState } from '@rexmas/rexmas-shared/lib/utils/hooks';
import { resetPassword as resetPasswordAction } from '../../../redux/actions/session';
import rexIcon from '../../../img/rex-logo.svg';
import { pathLanguageCode } from '../../../conf/constants/constants';

function ResetPassword() {
  const history = useHistory();
  const isConsultant = window.location.pathname.includes('consultor');
  let pathRedirect = `/remuneraciones/${pathLanguageCode}/login`;

  if (isConsultant) {
    pathRedirect = `/remuneraciones/${pathLanguageCode}/consultor/login`;
  }

  const [state, setState] = useSimpleState({
    isLoading: false,
    successfullSendEmail: false,
    isButtonActive: false,
    username: '',
    usernameError: '',
    pathRedirect,
  });

  const [resetPassword] = useActions([resetPasswordAction]);
  const resetPasswordHandle = () => {
    const { username } = state;
    resetPassword(username, () => null).then((response) => {
      if (response?.mensaje != null) {
        setState({ successfullSendEmail: true });
      } else {
        setState({ isLoading: false });
      }
    });
  };

  const validateData = () => {
    if (state.username.length < 1) {
      setState({ usernameError: 'Escriba 1 carácter o más' });
      return false;
    }
    return true;
  };

  const setPropertyChange = (prop, value) => {
    if (['username'].includes(prop)) {
      const isButtonActive = value !== '';
      return setState({ [`${prop}Error`]: '', [prop]: value, isButtonActive });
    }
    return setState({ [prop]: value });
  };

  const handleUsernameChange = (username) => (
    setPropertyChange('username', username)
  );

  const handleShowPasswordClick = () => {
    setState({ showPassword: !state.showPassword });
  };

  const handleButtonClick = () => {
    if (!validateData()) return;
    setState({ isLoading: true });
    resetPasswordHandle();
  };

  const handleBackButtonClick = () => {
    history.push(pathRedirect);
  };

  return (
    <ResetPasswordTemplate
      username={state.username}
      usernameError={state.usernameError}
      password={state.password}
      passwordError={state.passwordError}
      showPassword={state.showPassword}
      onUsernameChange={handleUsernameChange}
      onShowPasswordClick={handleShowPasswordClick}
      onSubmit={handleButtonClick}
      onBackButtonClick={handleBackButtonClick}
      isButtonActive={state.isButtonActive}
      successfullSendEmail={state.successfullSendEmail}
      isLoading={state.isLoading}
      pathRedirect={state.pathRedirect}
      isAdmin
      logo={rexIcon}
    />
  );
}

export default ResetPassword;
